import { getFeatureSwitchStatic } from '../utils/general';

export const PRINT_LABEL_MINIMUM_VERSION = {
  iOS:
    (getFeatureSwitchStatic('iOSPrintLabelVersion', false) as string) ||
    '7.34.0',
  Android:
    (getFeatureSwitchStatic('AndroidPrintLabelVersion', false) as string) ||
    '7.34.0',
};

export const isScheduledPickupEnabled = () =>
  getFeatureSwitchStatic('isScheduledPickupEnabled', true, false);

/**
 * ROS (Return Options Service) migration switch.
 * When ON, eligibility is sourced from the consolidated v2 endpoint and the FE
 * stops re-applying the O&P returnAllowed* combos itself. When OFF, the existing
 * `checkEligibility` path stays fully live (mirrors the enableKeepItReturns
 * pattern so FE/BE deploy independently).
 * This flag has behavioral impact beyond the fetch: it changes item-eligibility
 * derivation (`getItemEligibilities`), the in-store-only short-circuit
 * (`checkIsInStoreOnlyReturn`), and disables the legacy presentation overwrites
 * (QuantityItem weight/hazmat flip, SelectItemsToReturn SORIS strip).
 * Exception: QuantityItem's edit-drawer weight gate stays live under the flag.
 * That one is not a presentation overwrite — it is the only thing stopping a
 * quantity edit from crossing the weight line before the services are re-asked.
 * A review-screen edit does now re-ask them, but the gate still runs first and
 * is what keeps an over-weight quantity from being sent at all. Do not fold it
 * in with the flip.
 * NOTE: keep OFF in all shared envs until every ROS story has landed, not merely
 * the v2 eligibility endpoint. The flag also gates the fraud report, which now
 * has its identifier: the Return Methods call holds it from the response the
 * fraud check answered on. The report is skipped, visibly, when no decision
 * arrived — a fraud source that is down is a soft failure the customer
 * completes through, not a reason to withhold the return.
 */
export const isROSEnabled = () =>
  getFeatureSwitchStatic('enableROS', true, false);
